export default __webpack_public_path__ + "static/media/Client Logos – 03 – Hopper.d5977041.svg";